import React from 'react'
import { useSlateStatic } from 'slate-react'
import { Registry } from '@react-registry'
import { Editor } from 'slate'

import { OutdentationIcon } from '../../../utils/Icon'
import { elementCategories } from '../../elementCategories'
import { outdentNode, isNodeNotIndented, isNodeAligned, isInTable } from '../utils'
import { outdentMultipleListItems, outdentMultipleListItemsForUpdatedListStructure } from '../../list/ListItem/utils'
import { ElementWithType } from '../../../../../../../utils/types'

// Shortcut handling for Shift+Tab is managed centrally; no per-button shortcut needed

export const Outdentation = (props) => {
  const editor = useSlateStatic()

  const handleMouseDown = (event) => {
    event.preventDefault()
    
    const { selection } = editor
    const rteVersion = (editor as any).rteVersion
    if (selection) {
      const [li] = Editor.nodes(editor, {
        match: (n: ElementWithType) => n.type === 'li',
        mode: 'lowest'
      })

      if (li) {
        if (rteVersion >= 1) {
          outdentMultipleListItemsForUpdatedListStructure(editor)
        } else {
          outdentMultipleListItems(editor)
        }
      }
      else if (isInTable(editor)) {
        return
      }
      else {
        // Handle regular element outdentation - allow from any cursor position when using icon
        outdentNode(editor)
      }
    }
  }

  return (
    <React.Fragment>
      {props.children({
        handleMouseDown,
        active: false, // Outdent is a boolean operation, never active
        isDisable: {
          func: ({ editor }) => isInTable(editor) || isNodeAligned(editor) || isNodeNotIndented(editor),
          params: { editor }
        }
      })}
    </React.Fragment>
  )
}

Registry.register(
  {
    iconName: <OutdentationIcon />,
    category: elementCategories.INDENTATION,
    title: 'Outdent',
    slashTitle: 'Outdent',
    template: '',
    IngressComponent: Outdentation,
    isContentStackElement: true,
    inBasicToolbar: false,
    canCustomize: false,
    keywords: ['outdent']
  },
  { id: 'outdent', registry: 'v2.element' }
)